export class Citizenship {
  usCitizenId: number;
  permanentResident: string;

  constructor() {
    this.usCitizenId = 0,
      this.permanentResident = '';
  }
}

export class Identity {
  avatarURL: string;
  firstName: string;
  middleInitial: string;
  lastName: string;
  genderClassId: number;
  birthdate: any;
  gradeClassId: number;
  graduationYear: number;
  graduationMonth: any;
  raceClassId: number;
  citizenship: Citizenship;
  efc: number;
  familySize: number;

  /**
   *
   */
  constructor() {
    this.avatarURL = '',
    this.firstName = '',
    this.middleInitial = '',
    this.lastName = '',
    this.genderClassId = 0,
    this.birthdate = '',
    this.graduationMonth = 0,
    this.graduationYear = 0,
    this.raceClassId = 0,
    this.gradeClassId = 0;
    this.citizenship = new Citizenship();
    this.efc = -1;
    this.familySize = 1;
  }
}

